// Рівні доступу до записів архіву — ключі ті самі, що в бекенді
// (backend/src/api/archive/services/archive.js)

export const ARCHIVE_ACCESS = [
  { id: 'all', label: 'Усі', short: '' },
  { id: 'users', label: 'Ті, хто увійшов', short: 'Після входу' },
  { id: 'twitch', label: 'Саби Twitch', short: 'Саби Twitch' },
  { id: 'mono', label: 'Монобаза', short: 'Монобаза' },
  { id: 'subs', label: 'Саби Twitch або Монобаза', short: 'Саби / Монобаза' },
  { id: 'admins', label: 'Тільки адміни (приховано)', short: 'Приховано' }
]

export const archiveAccessOf = (id) => ARCHIVE_ACCESS.find((a) => a.id === id) || ARCHIVE_ACCESS[0]

/** Чому глядач не бачить запис — для екрана замість плеєра */
export const archiveLockReason = (access) =>
  ({
    users: 'Запис доступний після входу',
    twitch: 'Запис доступний лише сабам Twitch',
    mono: 'Запис доступний лише Монобазі',
    subs: 'Запис доступний сабам Twitch і Монобазі'
  })[access] || 'Запис закритий'

export const formatArchiveDate = (iso, withTime = true) => {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString('uk-UA', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {})
  })
}
